<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[1000px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">
              ประวัติการนำเข้า-ใช้ไป
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div
            class="max-h-[642px] flex flex-col p-[20px] gap-[10px] bg-[#FFF] overflow-auto"
          >
            <SearchBox
              :placeholder="'ค้นหา ชื่อทรัพยากร, ชื่อผู้กระทำ'"
              v-model="filter.search"
              @update:modelValue="
                () => {
                  (filter.page = ''), debouncedFetch();
                }
              "
            />
            <div
              class="w-full flex items-center justify-between gap-[10px] flex-wrap"
            >
              <div
                class="w-full sm:w-fit flex items-center gap-[10px] flex-wrap sm:flex-nowrap"
              >
                <!-- datePicker -->
                <DatePicker2
                  :containerClass="'w-full sm:max-w-[257px]'"
                  :modelValue="range"
                  :placeholder="'เลือกช่วงเวลาที่กระทำ'"
                  :isRange="true"
                  @update:modelValue="(date) => selectRange(date)"
                />
                <!-- datePicker -->
                <SelectBoxComponent
                  :selectContainerClass="'w-full sm:max-w-[164px]'"
                  :inputId="'filter11'"
                  :isFilter="true"
                  :keyValue="'action'"
                  :keyName="'name'"
                  :options="Selector.sortOption1"
                  :value="filter.sort"
                  :placeholder="'แสดงรายการล่าสุด'"
                  @update:modelValue="
                    (res) => {
                      filter.sort = res;
                      filter.page = '';
                      getData();
                    }
                  "
                />
              </div>
              <ButtonComponent
                :icon="'DownloadIcon'"
                :bClass="'btn_shadow--32 max-w-[151px]'"
                :label="'ดาวน์โหลดรายงาน'"
                :href="exportStockUrl"
              />
            </div>
            <div class="w-full">
              <!-- filter bar -->
              <div class="overflow-scroll">
                <div class="min-w-[620px] flex items-center gap-[4px]">
                  <div
                    v-for="row in allProductGroup"
                    :key="row.id"
                    class="filterBar"
                    :class="{
                      active: String(filter.group_id ?? '') === String(row.id),
                    }"
                    @click="
                      () => {
                        const isSame =
                          String(filter.group_id ?? '') === String(row.id);
                        if (!isSame) {
                          filter.group_id = row.id;
                          filter.page = '';
                          getData();
                        }
                      }
                    "
                  >
                    <span class="PC_Body2-R">{{ row.name }}</span>
                  </div>
                </div>
              </div>
              <!-- filter bar -->
              <!-- table -->
              <div
                v-if="allStockList.length > 0"
                class="h-[413px] overflow-auto"
              >
                <table class="min-w-[960px]">
                  <thead>
                    <tr>
                      <th
                        class="w-[10%] min-w-[92px] max-w-[92px] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> วันที่กระทำ </span>
                      </th>
                      <th
                        class="w-[5%] min-w-[54px] max-w-[54px] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> เวลา </span>
                      </th>
                      <th
                        class="w-[21%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ชื่อทรัพยากร </span>
                      </th>
                      <th
                        class="w-[12%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> นำเข้า </span>
                      </th>
                      <th
                        class="w-[12%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ใช้ไป </span>
                      </th>
                      <th
                        class="w-[25%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> สรุปยอด </span>
                      </th>
                      <th
                        class="w-[15%] py-[16px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-l-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ชื่อผู้กระทำ </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in allStockList"
                      :key="rowIndex"
                      :class="[
                        '!border-none',
                        { 'bg-[#FBEFF8]': (rowIndex + 1) % 2 === 0 },
                      ]"
                    >
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ $formatDate2(row.created_at) }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ $formatTime1(row.created_at) }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.name }}
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span
                          v-if="
                            Number(row?.type) === 1 || Number(row?.type) === 3
                          "
                          class="PC_Body2-R text-[#1F1D1F]"
                        >
                          {{ $numberAndComma(Number(row?.amount ?? 0)) }}
                        </span>
                        <span v-else class="PC_Body2-R text-[#1F1D1F]">
                          0
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span
                          v-if="
                            Number(row?.type) === 2 || Number(row?.type) === 4
                          "
                          class="PC_Body2-R text-[#1F1D1F]"
                        >
                          {{ $numberAndComma(Number(row?.amount ?? 0)) }}
                        </span>
                        <span v-else class="PC_Body2-R text-[#1F1D1F]">
                          0
                        </span>
                      </td>
                      <td class="p-[10px] !border-none">
                        <div
                          class="flex items-center justify-between gap-[10px]"
                        >
                          <span class="PC_Body2-R text-[#1F1D1F]">
                            {{ $numberAndComma(row.total) || 0 }}
                          </span>
                          <div class="flex items-center gap-[10px]">
                            <div
                              v-if="
                                Number(row?.type) === 3 ||
                                Number(row?.type) === 4
                              "
                              class="flex items-center justify-center py-[2px] px-[8px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF]"
                            >
                              <span
                                v-if="Number(row?.type) === 3"
                                class="PC_caption-R text-[#1F1D1F]"
                              >
                                โอนเข้า
                              </span>
                              <span
                                v-else-if="Number(row?.type) === 4"
                                class="PC_caption-R text-[#1F1D1F]"
                              >
                                โอนออก
                              </span>
                            </div>
                            <ButtonComponent
                              :icon="'InfoIcon'"
                              :bClass="'btn_shadow--2'"
                              @clicked="() => detail(row)"
                            />
                          </div>
                        </div>
                      </td>
                      <td class="p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.created_name }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-if="allStockList.length <= 0"
                class="min-h-[413px] flex flex-col items-center justify-center"
              >
                <NoInfoYetComponent :col="'10'" :icon="'ResourcesIcon'" />
              </div>
            </div>
            <!-- table -->
            <!-- pagination for modal -->
            <PaginationComponent
              :perPageId="'perpagemodal'"
              :items="pagination"
              @selectedPage="handlePage"
            />
            <!-- pagination for modal -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { Selector } from "@/components/Utilities/javascripts/constants";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";
import { useAuthStore } from "@/pinia/authStore";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const { $formatDate3 } = useGlobals();
const productStore = useProductStore();
const auth = useAuthStore();
const { allProductGroup, allStockList } = storeToRefs(productStore);

// const shelter = ref({});
const defaultFilter = {
  paginate: 10,
  search: "",
  sort: "desc",
  start_date: "",
  end_date: "",
  group_id: 1,
  shelter_id: "",
};
const filter = ref({ ...defaultFilter });
const range = ref(null);
const pagination = ref(null);

const modalIsOpened = ref(false);
const emit = defineEmits(["open", "status", "detail"]);

const exportStockUrl = computed(() => {
  // ใช้ origin ปัจจุบัน เช่น https://dev.g-eoc.com หรือ http://localhost:5173
  const base = new URL("/api/export-stock", window.location.origin).toString();
  const clean = Object.fromEntries(
    Object.entries(filter.value).filter(
      ([_, v]) => v !== "" && v !== null && v !== undefined
    )
  );
  const qs = new URLSearchParams(clean).toString();
  return qs ? `${base}?${qs}` : base;
});

const openModal = async (data, inShelter) => {
  range.value = null;
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  filter.value = { ...defaultFilter };
  if (inShelter) {
    filter.value.shelter_id =
      (await JSON.parse(sessionStorage.getItem("shelterID"))?.id) || 0;
  } else {
    filter.value.shelter_id = 0;
  }
  getData();
};

const closeModal = () => {
  filter.value.search = "";

  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const getData = async () => {
  await productStore
    .getStockList(filter.value)
    .then((response) => {
      if (response.status == 200) {
        pagination.value = response.data.data;
      }
    })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};

const debouncedFetch = debounce(getData, 300);

const selectRange = (date) => {
  filter.value.page = "";
  range.value = date;
  if (date != null) {
    filter.value.start_date = $formatDate3(date[0]);
    filter.value.end_date = $formatDate3(date[1]);
  } else {
    filter.value.start_date = "";
    filter.value.end_date = "";
  }
  getData();
};

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

const detail = (data) => {
  emit("detail", data);
};

const exportStock = () => {
  productStore.exportStockList(filter.value);
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.filterBar {
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;

  border-radius: 6px 6px 0px 0px;
  border: 1px solid #b7b2b5;
  background: #fff;
  span {
    color: #7c7379;
  }
  &.active {
    span {
      color: #1f1d1f;
    }
  }
}
</style>
